import { MasterButton, Modal, InputTextMaster } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState, useContext } from "react";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { urlUpdatePembelian } from "../../helpers";

const ModalBiaya = ({ setShowModal, setNewDataPembelianList }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const { formData, setFormData } = useContext(FormContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.biayalain2 === "") {
        defaultToastError("Biaya lain tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        const api = await instance4.post(urlUpdatePembelian, {
          id: formData.id,
          potongan: convertToValidPrice(formData.potongan2),
          ongkos: convertToValidPrice(formData.ongkos2),
          biayalain: convertToValidPrice(formData.biayalain2),
          tax: convertToValidPrice(formData.tax2),
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setNewDataPembelianList();
        } else {
          defaultToastError(res?.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={"Biaya"} show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container direction="row" alignItems="center">
          <Grid item sm={12}>
            <InputTextMaster
              name="biayalain2"
              label="BIAYA LAIN"
              id="biayalain2"
              placeholder="Biaya Lain"
              value={formData.biayalain2}
              onInput={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  biayalain: convertToValidPrice(val),
                  biayalain2: formatRupiah(val),
                });
              }}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#fff",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="ongkos2"
              label="ONGKOS"
              id="ongkos2"
              placeholder="Ongkos"
              value={formData.ongkos2}
              onInput={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  ongkos: convertToValidPrice(val),
                  ongkos2: formatRupiah(val),
                });
              }}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#fff",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>
        </Grid>

        <div>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="submit"
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Modal>
  );
};

export default ModalBiaya;
